import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import * as v from 'valibot'

import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { setLocalStorageItem } from '@/core/utils/localStorage/setLocalStorageItem'
import { GrowthMapPage } from '@/growth-map/components/GrowthMapPage/GrowthMapPage'
import { skillsCurrentOptions } from '@/growth-map/queries/useSkillsCurrent'

const searchSchema = v.object({
  show_completed_courses: v.optional(v.boolean(), false),
})

const defaultSearch: v.InferOutput<typeof searchSchema> = {
  show_completed_courses: false,
}

export const Route = createFileRoute('/_learning/growth-map/$skillSlug')({
  beforeLoad: ({ cause, search }) => {
    if (cause === 'stay') {
      setLocalStorageItem(
        'growth-map-show-completed-courses',
        search.show_completed_courses,
      )
    }
  },
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(skillsCurrentOptions())
  },
  component: RouteComponent,
  pendingComponent: () => <LoadingIndicator />,
  validateSearch: searchSchema,
  search: {
    middlewares: [stripSearchParams(defaultSearch)],
  },
})

function RouteComponent() {
  return <GrowthMapPage />
}
